<!--
 * @Author: your name
 * @Date: 2020-12-28 13:47:34
 * @LastEditTime: 2021-02-02 15:28:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zcjb\src\components\letter_nav\letter.nav.vue
-->

<template>
  <div>
    <div class="bar">
      <a v-for="(nav, index) in navData" :key="index" @click="getpath(nav.path)" :class="getClass(nav.applyType)">
        {{ nav.text }}
      </a>
    </div>
  </div>

</template>
<script>
import './index.css'
export default {
  props: {
    applyType: {
      default: '8000',
      type: String,
    },
  },

  watch: {
    applyType: {
      deep: true,
      handler(newVal, oldVal) {
        console.log(newVal);
      }
    }
  },
  computed: {
    isHlj() {
      return this.$store.state.letter.isHlj
    }
  },
  methods: {
    getpath(data) {
      if (this.$route.name === data) return
      // 白名单透传：只保留业务参数，过滤内部导航标记（step2Id/step1Id）
      // 这些标记由 step1/step2 的同流程导航产生，不该被 Nav 跨保函透传
      const Q = this.$route.query
      const cleanQ = {}
      const allow = ['orderID', 'orderId', 'order', 'outerOrderNo', 'reapply', 'web_type', 'apiId', 'apiCode']
      allow.forEach(k => { if (Q[k] !== undefined) cleanQ[k] = Q[k] })
      this.$router.push({ name: data, query: cleanQ })
    },
    getClass(applyType) {
      return this.applyType == applyType ? 'activeBar' : 'item'
    },
  },
  created() {
    const { outerOrderNo, order, orderID } = this.$route.query
    const qOrderId = order || orderID || outerOrderNo
    if (this.isCqsw) {
      if (qOrderId) {
        const currentPath = window.location.href
        this.navData = this.navData.filter(item => {
          return currentPath.includes(item.path)
        })
        this.$store.commit("letter/setApplyType", this.navData[0].applyType)
      } else {
        this.$store.commit("letter/setApplyType", '')
        this.navData = this.navData.filter(item => { return item.applyType === '9600' || item.applyType === '9100' })
      }
    }
    if (this.isHlj) {
      this.navData = this.navData.filter(item => { return item.applyType === '9600' || item.applyType === '9100'})
    }
  },
  watch: {
  },
  data() {
    return {
      isCqsw: this.$store.state.letter.isCqsw,
      navData: [
        {
          text: '申请银行保函',
          path: 'applyBankMain',
          applyType: '8000',
        },
        {
          text: '申请电子担保保函',
          path: 'guaranteeBankView',
          applyType: '9600',
        },
        {
          text: '申请保险保函',
          path: 'applyInsurance',
          applyType: '7000',
        },
        {
          text: '申请履约保函',
          path: 'applicationPerformance',
          applyType: '9100',
        },
      ],
    }
  },
}
</script>
<style scoped lang='scss'>
.bar {
  a {
    flex: 1;
  }
}
</style>
